import { render, staticRenderFns } from "./checkbox-group.vue?vue&type=template&id=089e3a18"
import script from "./checkbox-group.vue?vue&type=script&lang=js"
export * from "./checkbox-group.vue?vue&type=script&lang=js"
import style0 from "./checkbox-group.vue?vue&type=style&index=0&id=089e3a18&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports